<template>
  <main-layout v-if="!isAuthPage">
    <router-view :key="$route.fullPath"/>
  </main-layout>
  <router-view v-else></router-view>

</template>

<script>
import MainLayout from './layouts/MainLayout.vue';
import {useRoute} from 'vue-router';
import {computed, onMounted, onUnmounted} from 'vue';
import { initVersionCheck, stopVersionCheck } from './utils/versionCheck';

export default {
  name: 'App',
  components: {
    MainLayout
  },
  setup() {
    const route = useRoute();

    // Check if current route is an auth page (login/register)
    const isAuthPage = computed(() => {
      return route.name === 'login' ||
          route.path.includes('/login/') || route.name === 'register' || route.path.includes('/register/') ||
          route.name === 'forgot-password' || route.name === 'reset-password' ||
          route.path.includes('/panel/') || route.name === 'panel'
          ;
    });

    // Initialize version checking on mount
    onMounted(() => {
      initVersionCheck();
    });

    // Cleanup on unmount
    onUnmounted(() => {
      stopVersionCheck();
    });

    return {
      isAuthPage
    };

  }
}
</script>